import axios from 'axios'
import { toData } from './util'

export function upsert(note): Promise {
  return axios.post('/api/notes', note).then(toData)
}

export function getByUserId(id): Promise {
  return axios.get(`/api/notes/user/${id}`).then(toData)
}

export function getByLicenseId(id): Promise {
  return axios.get(`/api/notes/license/${id}`).then(toData)
}

export function getByGroupId(id): Promise {
  return axios.get(`/api/notes/group/${id}`).then(toData)
}

export function getByCustomerId(id): Promise {
  return axios.get(`/api/notes/customer/${id}`).then(toData)
}

export function remove(id): Promise {
  return axios.delete(`/api/notes/${id}`).then(toData)
}
